<svg viewBox="0 0 16 16" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M13 15v-2h1v3H0V2h3v1H1v12h12zm.663-13.372H6.562v-1h8.985v8.985h-1V2.158l-8.744 8.744-.707-.707 8.567-8.567z"/>
</svg>
